import type { TrophyDefinition } from '@/types'

export const TROPHY_DEFINITIONS: TrophyDefinition[] = [
  {
    id: 'legendary_collector_bronze',
    label: 'Legendary Collector I',
    description: 'Hold 1 Legendary Fortune at the same time.',
    requirements: {
      legendary: 1,
    },
    category: 'rarity_hold',
  },
  {
    id: 'legendary_collector_silver',
    label: 'Legendary Collector II',
    description: 'Hold 3 Legendary Fortunes at the same time.',
    requirements: {
      legendary: 3,
    },
    category: 'rarity_hold',
  },
  {
    id: 'legendary_collector_gold',
    label: 'Legendary Collector III',
    description: 'Hold 5 Legendary Fortunes at the same time.',
    requirements: {
      legendary: 5,
    },
    category: 'rarity_hold',
  },
  {
    id: 'epic_collector_bronze',
    label: 'Epic Collector I',
    description: 'Hold 2 Epic Fortunes at the same time.',
    requirements: {
      epic: 2,
    },
    category: 'rarity_hold',
  },
  {
    id: 'epic_collector_silver',
    label: 'Epic Collector II',
    description: 'Hold 4 Epic Fortunes at the same time.',
    requirements: {
      epic: 4,
    },
    category: 'rarity_hold',
  },
  {
    id: 'epic_collector_gold',
    label: 'Epic Collector III',
    description: 'Hold 7 Epic Fortunes at the same time.',
    requirements: {
      epic: 7,
    },
    category: 'rarity_hold',
  },
  {
    id: 'balanced_keeper_1',
    label: 'Balanced Keeper I',
    description: 'Hold 1 of every rarity.',
    requirements: {
      common: 1,
      uncommon: 1,
      rare: 1,
      epic: 1,
      legendary: 1,
    },
    category: 'set_hold',
  },
  {
    id: 'balanced_keeper_2',
    label: 'Balanced Keeper II',
    description: 'Hold 3 Common, 3 Uncommon, 2 Rare, 1 Epic, 1 Legendary.',
    requirements: {
      common: 3,
      uncommon: 3,
      rare: 2,
      epic: 1,
      legendary: 1,
    },
    category: 'set_hold',
  },
]

export const TROPHY_ICON_BY_CATEGORY: Record<string, string> = {
  rarity_hold: 'trophy',
  set_hold: 'medal',
}

export const TROPHY_LOCK_ICON = 'lock'

